/**
 * Geography-oriented message path utils
 */

import { CanonicalDataType } from "./MessagePathRecord";

export type LatitudeDataType =
  | CanonicalDataType.LatDegFloat
  | CanonicalDataType.LatDegInt;

export type LongitudeDataType =
  | CanonicalDataType.LonDegFloat
  | CanonicalDataType.LonDegInt;

export function isLatitudeType(
  dataType: CanonicalDataType,
): dataType is LatitudeDataType {
  return (
    dataType === CanonicalDataType.LatDegFloat ||
    dataType === CanonicalDataType.LatDegInt
  );
}

export function isLongitudeType(
  dataType: CanonicalDataType,
): dataType is LongitudeDataType {
  return (
    dataType === CanonicalDataType.LonDegFloat ||
    dataType === CanonicalDataType.LonDegInt
  );
}

export function getCorrespondingGeoType(
  initialType: CanonicalDataType,
): CanonicalDataType | undefined {
  switch (initialType) {
    case CanonicalDataType.LatDegFloat:
      return CanonicalDataType.LonDegFloat;
    case CanonicalDataType.LonDegFloat:
      return CanonicalDataType.LatDegFloat;
    case CanonicalDataType.LatDegInt:
      return CanonicalDataType.LonDegInt;
    case CanonicalDataType.LonDegInt:
      return CanonicalDataType.LatDegInt;
    default:
      throw new Error("Unsupported canonical data type");
  }
}
